/* feela: Judge.me-Bewertungen auf Deutsch (Sortier-Label) und Datum im deutschen Format TT.MM.JJJJ – 2026-10-06 */
(function () {
  var scheduled = false;
  function fix() {
    scheduled = false;
    bewertungsHinweis();
    document.querySelectorAll('.jdgm-sort-dropdown-label').forEach(function (el) {
      if (el.textContent.trim() === 'Sort by') el.textContent = 'Sortieren nach';
    });
    document.querySelectorAll('.jdgm-rev__timestamp, .jdgm-rev-widg__timestamp, .jdgm-carousel-item__timestamp').forEach(function (el) {
      var m = el.textContent.trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (m) el.textContent = m[1] + '.' + m[2] + '.' + m[3];
    });
    // 2026-10-07: Judge.me schreibt ">> feela.® antwortete:" – die ">>" entfernen
    document.querySelectorAll('.jdgm-rev__replier-wrapper').forEach(function (el) {
      var n = el.firstChild;
      while (n && n.nodeType === 3 && !n.nodeValue.trim()) n = n.nextSibling;
      if (n && n.nodeType === 3 && /^\s*>>\s*/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/^\s*>>\s*/, '');
    });
  }
  // 2026-11-02: Hinweis zur Echtheit der Bewertungen (§ 5b Abs. 3 UWG) unter dem Kopf des Bewertungs-Widgets
  function bewertungsHinweis() {
    document.querySelectorAll('.jdgm-rev-widg__header').forEach(function (kopf) {
      var n = kopf.nextElementSibling;
      if (n && n.classList.contains('feela-bewertung-info')) return;
      var p = document.createElement('p');
      p.className = 'feela-bewertung-info';
      p.style.cssText = 'font-size:12px;line-height:1.45;color:#6b6b6b;margin:8px 0 12px';
      p.textContent = 'Bewertungen mit dem Hinweis „Verifiziert“ hat unser Bewertungstool Judge.me einem Kauf zugeordnet. Bei anderen Bewertungen prüfen wir nicht, ob ein Kauf stattgefunden hat.';
      kopf.insertAdjacentElement('afterend', p);
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; setTimeout(fix, 30); }
  }
  function start() {
    fix();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.nodeType === 1 && (t.closest('[class*="jdgm"]') || t.querySelector('.jdgm-rev__timestamp'))) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
